import { Box, Button, Link, Paper, Stack, Typography } from '@mui/material';
import TextField from '../../components/TextField/TextField';
import {
  SignInSx,
  PaperSx,
  TitleSx,
  ExplanationTextSx,
  ResetButtonSx,
  formSchema,
  FormData,
  CancelSx,
} from './ForgotPasswordProps';
import { useCustomForm } from '../../hooks/useCustomForm';
import ControlledField from '../../components/ControlledField/ControlledField';
import { TestIds } from '../../utils/dataTestIds';
import { showSnackbarAtom } from '../../store/snackbarStore';
import { useSetAtom } from 'jotai';
import { requestPasswordReset } from '../../apiClient/auth';

function ForgotPassword() {
  const showSnackbar = useSetAtom(showSnackbarAtom);
  const { control, handleSubmit, setValue } = useCustomForm(
    formSchema,
    {},
    {
      defaultValues: {
        email: '',
      },
    }
  );

  async function handleResetPassword(formData: FormData) {
    const { email } = formData;
    requestPasswordReset({
      username: email,
    });
    showSnackbar({
      text: 'A reset link has been sent if your email is registered',
      type: 'success',
    });
    setValue('email', '');
  }

  return (
    <Box sx={SignInSx}>
      <Paper
        sx={PaperSx}
        component={'form'}
        onSubmit={handleSubmit(handleResetPassword)}
      >
        <Typography sx={TitleSx}>Forgot password</Typography>
        <Typography sx={ExplanationTextSx}>
          Enter the email address you used when you joined and we’ll send you
          instructions to reset your password.
        </Typography>

        <ControlledField
          name="email"
          control={control}
          component={
            <TextField
              label="Email"
              placeholder="Enter your email"
              required
              fullWidth
              data-testid={TestIds.ForgotPassword.Email}
            />
          }
        />

        <Button
          sx={ResetButtonSx}
          data-testid={TestIds.ForgotPassword.SendResetInstructions}
          type="submit"
          variant="contained"
        >
          Send reset instructions
        </Button>
        <Stack alignContent={'center'} alignItems={'center'}>
          <Link
            href="/sign-in"
            underline="none"
            sx={CancelSx}
            data-testid={TestIds.ForgotPassword.Cancel}
          >
            Cancel
          </Link>
        </Stack>
      </Paper>
    </Box>
  );
}

export default ForgotPassword;
